import React, { Component } from 'react';
import TagComponent from 'components/tags/TagComponent.js';


/**
 * Shows all tags in alphabetical order and allows user
 * to click to add them
 */
class TagsChooserComponent extends Component {
    render() {
        return (
            <div>
              <div className="instructions-text">
                Click tags that fall under this category
              </div>
              <div className="tags-container">
                {this.props.tags.map(
                  tag =>
                        <TagComponent
                          chosenAlready={this.props.chosenSoFar.has(tag)}
                          chosen={this.props.tagsChosen.indexOf(tag) > -1}
                          onClick={() => this.props.onClickTag(tag)}
                          tag={tag}/>)}
              </div>
            </div>
        );
    }
}

export default TagsChooserComponent;
